(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-upsell-inject"] && !Shopify.designMode) return;
  try {
    
(function () {
  var configEl = document.getElementById('upsell-config-{{ section.id }}');
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

  var handles = (config.handles || []).filter(function (h) { return h && h.trim() !== ''; });
  if (!handles.length) return;

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function buildUpsellEl(products) {
    var wrap = document.createElement('div');
    wrap.className = 'pu-upsell';

    if (config.heading) {
      var h = document.createElement('p');
      h.className = 'pu-upsell__heading';
      h.textContent = config.heading;
      wrap.appendChild(h);
    }

    var list = document.createElement('div');
    list.className = 'pu-upsell__list';

    products.forEach(function (product) {
      if (!product || !product.available) return;
      var variant = product.variants[0];
      var price = variant.price;
      var comparePrice = variant.compare_at_price;
      var discountPct = comparePrice > price
        ? Math.round((comparePrice - price) * 100 / comparePrice)
        : 0;

      var item = document.createElement('div');
      item.className = 'pu-upsell__item';

      var img = product.featured_image
        ? '<a href="/products/' + product.handle + '" class="pu-upsell__img-link"><img src="' + product.featured_image + '&width=120" alt="' + product.title.replace(/"/g, '&quot;') + '" class="pu-upsell__img" loading="lazy" width="80" height="80"></a>'
        : '';

      var badge = discountPct > 0
        ? '<span class="pu-upsell__badge">' + discountPct + '% OFF</span>'
        : '';

      var compareHtml = comparePrice > price
        ? '<s class="pu-upsell__compare">' + money(comparePrice) + '</s>'
        : '';

      item.innerHTML = img +
        '<div class="pu-upsell__info">' +
          '<p class="pu-upsell__title">' + product.title + '</p>' +
          '<div class="pu-upsell__prices">' +
            '<span class="pu-upsell__price">' + money(price) + '</span>' +
            compareHtml + badge +
          '</div>' +
          '<form action="/cart/add" method="post" class="pu-upsell__form">' +
            '<input type="hidden" name="id" value="' + variant.id + '">' +
            '<button type="submit" class="pu-upsell__btn">Add to cart</button>' +
          '</form>' +
        '</div>';

      list.appendChild(item);
    });

    wrap.appendChild(list);
    return wrap;
  }

  function inject(upsellEl) {
    var targets = [
      '[data-add-to-cart-bar]',
      '[data-product-blocks]',
      '.product-form__cart-submit',
      '[data-add-to-cart]',
      '.product-single__add-to-cart',
      '.shopify-product-form'
    ];

    var anchor = null;
    for (var i = 0; i < targets.length; i++) {
      anchor = document.querySelector(targets[i]);
      if (anchor) break;
    }

    if (!anchor) return;

    var insertAfter = anchor.closest('form') || anchor;
    insertAfter.parentNode.insertBefore(upsellEl, insertAfter.nextSibling);

    var style = document.createElement('style');
    style.textContent = [
      '.pu-upsell{border:1px solid #e0e0e0;padding:16px;margin-top:16px}',
      '.pu-upsell__heading{font-size:.72rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;margin:0 0 12px}',
      '.pu-upsell__list{display:flex;flex-direction:column;gap:12px}',
      '.pu-upsell__item{display:flex;gap:12px;align-items:center}',
      '.pu-upsell__img-link{flex-shrink:0}',
      '.pu-upsell__img{width:80px;height:80px;object-fit:cover;display:block;background:#f4f4f4}',
      '.pu-upsell__info{flex:1}',
      '.pu-upsell__title{font-size:.83rem;font-weight:600;margin:0 0 4px}',
      '.pu-upsell__prices{display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:6px}',
      '.pu-upsell__price{font-size:.83rem;font-weight:600}',
      '.pu-upsell__compare{font-size:.78rem;color:#999}',
      '.pu-upsell__badge{font-size:.68rem;font-weight:700;color:#c0392b;text-transform:uppercase}',
      '.pu-upsell__form{margin:0}',
      '.pu-upsell__btn{font-size:.72rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;text-decoration:underline;background:none;border:none;padding:0;cursor:pointer;color:inherit}',
      '.pu-upsell__btn:hover{opacity:.65}'
    ].join('');
    document.head.appendChild(style);
  }

  Promise.all(handles.map(fetchProduct)).then(function (products) {
    var valid = products.filter(function (p) { return p && p.available; });
    if (!valid.length) return;
    var el = buildUpsellEl(valid);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { inject(el); });
    } else {
      inject(el);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
